import { City } from "../../types";
import styled, { css } from "styled-components/macro";
import { ValidationError } from "../../common/errors/ValidationError";
import { Autocomplete } from "../../common/inputs/Autocomplete";
import { getFuzzyCitiesSearchList } from "../../services/apiService";
import { cssVariables } from "../../styles";
import { getLocationLabel } from "../../utils/utils";
//import { SearchBarHeightInRem } from "./SearchBar";

export const SearchBarHeightInRem = 5;

interface Props {
  id: string;
  placeholder: string;
  title: string;
  onSelect?: (city: City) => void;
  onClear?: () => void;
  value: City | null;
  errorMessage: string | undefined;
  disabled?: boolean;
}

export const CityInput: React.FC<Props> = ({
  id,
  placeholder,
  onSelect,
  onClear,
  value,
  title,
  errorMessage,
  disabled = false,
}) => {
  const handleOnSelect = (city: City) => {
    if (onSelect) {
      onSelect(city);
    }
  };

  return (
    <InputWrapper>
      <Title htmlFor={id}>{title}</Title>
      <StyledAutoComplete
        id={id}
        name={id}
        placeholder={placeholder}
        onSelect={handleOnSelect}
        onClear={onClear ? () => onClear() : undefined}
        value={value}
        getOptionList={getFuzzyCitiesSearchList}
        getSelectedOptionLabel={getLocationLabel}
        getListHtmlOptionLabel={getLocationLabel}
        wrapperHeightInRem={SearchBarHeightInRem - 0.5}
        sidePaddingInRem={0.1}
        disabled={disabled}
      />
      {errorMessage && <ValidationError message={errorMessage} />}
    </InputWrapper>
  );
};
const InputWrapper = styled.div`
  height: 100%;
  display: flex;
  background-color: ${cssVariables.colors.white};
  padding: 0 3rem;
  flex-direction: column;
  justify-content: center;
  width: 400px;
`;

const Title = styled.label`
  color: ${cssVariables.colors.eyGray};
  height: 3rem;
  font-size: 1.4rem;
  letter-spacing: 0;
  line-height: 2.4rem;
`;

export const InputStyle = css`
  font-size: 1.5rem;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 2.4rem;
  background-color: lightgray;
  border: 1;
`;

const StyledAutoComplete = styled(Autocomplete)`
  background-color: lightgray;
  & input {
    ${InputStyle}
  }
` as typeof Autocomplete; // we need to do this as styled components doesn't return the generic type
